// Module
var code = `<div tabindex="0" class="local-override" ng-if="\$ctrl.task" ng-keyup="\$ctrl.closeDialog(\$event)">
  <div class="local-override__content">

    <form class="local-override__inputs" name="passwordForm">
      <button type="button" class="close" ng-click="\$ctrl.close(\$event)" aria-hidden="true">&times;</button>

      <!-- Only if approval user id is unknown during override -->
      <div ng-if="!\$ctrl.task.approvalUserId">
        <div>
          <div ng-if="\$ctrl.task.taskGroup === 'COMMAND_APPROVAL'" class="approval-user-select-title" >{{\$ctrl.task.name | translateEnum:'COMMAND'}}</div>
          <div ng-if="\$ctrl.task.taskGroup !== 'COMMAND_APPROVAL'" class="approval-user-select-title" >{{\$ctrl.task.name}}</div>
        </div>
        <div ng-if="\$ctrl.task.localOverrideLevel || \$ctrl.task.localOverrideLevel === 0">
          <div class="approval-user-select-title">Level {{\$ctrl.task.localOverrideLevel + 1}}</div>
        </div>
        <div class="labelled-field">
          <label for="approval-user-select">Approval user</label>
          <select
            required
            id="approval-user-select"
            ng-model="\$ctrl.selectedUser"
            ng-change="\$ctrl.updatePinAvailability()"
            ng-options="u.fullName for u in \$ctrl.authorizedUsers">
          </select>
        </div>
      </div>

      <div ng-if="\$ctrl.task.approvalUserId" class="approval-user-select-title">
        <p>Approval user:</p>
        {{\$ctrl.selectedUser.fullName}}
      </div>

      <p class="local-override__title">Please enter pin number:</p>
      <div>
        <input class="pin-input-field" type="password" id="pinField1" maxlength="1" required
               ng-change="\$ctrl.goToNextField(\$ctrl.field1,'#pinField2')" ng-model="\$ctrl.field1"
               ng-disabled="!\$ctrl.pinEnabled">
        <input class="pin-input-field" type="password" id="pinField2" maxlength="1" required
               ng-change="\$ctrl.goToNextField(\$ctrl.field2,'#pinField3')" ng-model="\$ctrl.field2"
               ng-disabled="!\$ctrl.pinEnabled">
        <input class="pin-input-field" type="password" id="pinField3" maxlength="1" required
               ng-change="\$ctrl.goToNextField(\$ctrl.field3,'#pinField4')" ng-model="\$ctrl.field3"
               ng-disabled="!\$ctrl.pinEnabled">
        <input class="pin-input-field" type="password" id="pinField4" maxlength="1" required
               ng-model="\$ctrl.field4"
               ng-disabled="!\$ctrl.pinEnabled">
      </div>
      <button class="btn" id="local-override__submit" ng-click="\$ctrl.save()" ng-disabled="passwordForm.\$invalid">
        Confirm
      </button>
    </form>
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/local-override/local-override.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;